import React from 'react';
import {View} from 'react-native';
import {constant} from 'lodash/fp';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

import {FEATURE_FLAGS} from '/DevFeatureFlags';

interface LoadingProps {
  renderTitle: () => string;
}

const Loading: React.FC<LoadingProps> = ({
  renderTitle = constant(''), // Default value for renderTitle
}: LoadingProps) => {
  const {tt} = useTranslation('reportCardContent.teamRank');

  return (
    <View style={styles.base}>
      <Gutter style={styles.headerContainer}>
        <Text variant="heading" style={styles.header}>
          {renderTitle()}
        </Text>
      </Gutter>
      <View style={styles.listItemContainer}>
        <Gutter>
          <ListItem
            style={{base: styles.listItem}}
            readonly={true}
            label={
              <Text>{tt('highestRankAchieved', 'Highest Rank Achieved')}</Text>
            }
            suffix={<LoadingBox style={styles.loadingHighestAchievedRank} />}
          />
        </Gutter>
        {FEATURE_FLAGS.showCertificationReference && (
          <Gutter>
            <ListItem
              style={{base: styles.listItem}}
              readonly={true}
              label={<Text>{tt('certified', 'Certified')}</Text>}
              suffix={<LoadingBox style={styles.loadingBoxCertified} />}
            />
          </Gutter>
        )}
      </View>
    </View>
  );
};

export default Loading;
